import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fafd55c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-developer-card__container" }
const _hoisted_2 = { class: "m-developer-card__title" }
const _hoisted_3 = { class: "m-developer-card__content mt--12" }
const _hoisted_4 = { class: "m-developer-card__content-info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Сдано: ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Строится: ", -1))
const _hoisted_7 = { class: "items-in-line flex-start gap--5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Строит с: ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "underline" }, "Витрина ЖК", -1))
const _hoisted_10 = { class: "m-developer-card__content-icons" }
const _hoisted_11 = ["src"]

import { SmallDeveloperCardType } from '@/types/DeveloperTypes';
import { computed } from 'vue';
import { useAppStore } from '@/store/modules/app';
import { SaveDocsBtn } from '@/components/Cards/CardsComponents';


export default /*#__PURE__*/_defineComponent({
  __name: 'MediumDeveloperCard',
  props: {
    isFirst: { type: Boolean, default: false },
    developer: {},
    withLink: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const window = computed((): number => {
  return useAppStore().window;
});

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_card, { class: "m-developer-card" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.developer.url ? 'router-link' : 'span'), {
            to: { name: 'developer', params: { url: _ctx.developer.url } },
            class: "m-developer-card__img"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_image, {
                height: window.value > 600 ? '119' : '90',
                name: _ctx.developer.title,
                src: _ctx.developer.logo,
                title: _ctx.developer.title,
                width: window.value > 600 ? '204' : '100%',
                "border-radius": "",
                contain: "",
                version: "v4"
              }, null, 8, ["height", "name", "src", "title", "width"])
            ]),
            _: 1
          }, 8, ["to"])),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.developer.title || '-'), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _hoisted_5,
                  _createElementVNode("span", null, _toDisplayString(_ctx.developer.builtCount || '-'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_6,
                  _createElementVNode("span", null, _toDisplayString(_ctx.developer.buildingCount || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", null, _toDisplayString(_ctx.developer.yearOfFoundation || '-'), 1)
                ])
              ]),
              _createElementVNode("div", null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.developer.url ? 'router-link' : 'span'), {
                  to: {
                  name: 'developer',
                  params: { url: _ctx.developer.url },
                  hash: '#allLCD',
                }
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["to"]))
              ]),
              (_ctx.withLink)
                ? (_openBlock(), _createBlock(_component_base_button, {
                    key: 0,
                    disabled: !_ctx.developer.url,
                    href: { name: 'developer', params: { url: _ctx.developer.url } },
                    "all-block-width": "",
                    class: "none-Mobile",
                    "style-type": "coloredBorder",
                    text: "Подробнее"
                  }, null, 8, ["disabled", "href"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(SaveDocsBtn), {
                docs: _ctx.developer.documents || [],
                class: "scale"
              }, null, 8, ["docs"]),
              (_ctx.withLink)
                ? (_openBlock(), _createBlock(_component_base_button, {
                    key: 0,
                    disabled: !_ctx.developer.url,
                    href: { name: 'developer', params: { url: _ctx.developer.url }, hash: '#map' },
                    icon: "",
                    "style-type": "coloredBorder",
                    withoutActive: ""
                  }, {
                    icon: _withCtx(() => [
                      _createElementVNode("img", {
                        src: require('@/assets/img/mainPage/icons/icon-map.png'),
                        alt: "map"
                      }, null, 8, _hoisted_11)
                    ]),
                    _: 1
                  }, 8, ["disabled", "href"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})